import { schema } from 'normalizr';
import { SCHEMA_TYPE_NOTIFICATIONS } from '../constants/schemaTypes';

import upperFirst from 'lodash/upperFirst';
import userSchema from './user';
import orgSchema from './org';

const notificationSchema = new schema.Entity(
  SCHEMA_TYPE_NOTIFICATIONS,
  {
    owner: userSchema,
    org: orgSchema,
  },
  {
    processStrategy: (value) => {
      let message = upperFirst(value.message);
      return { ...value, message };
    },
  },
);

export default notificationSchema;
